import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "5 apps with the modern web stack",
  "description": "",
  "published": "2020-01-29T00:00:00.000Z",
  "redirect_from": ["/blog/5-apps-with-the-modern-web-stack/swizec/9317"],
  "categories": "Side Projects",
  "hero": "./img/MggFX7u.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We've been talking about the hyper productive modern web stack and let's be honest: It needs a better name.`}</p>
    <p>{`Naming is hard, my friend. One of the 2 most difficult things in software engineering: Naming things, cache invalidation, and off-by-one errors.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "64px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5d77bfb8aeb207e785d8df46472dbdd9/6b377/MggFX7u.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M160%2057l-23%202c-4%201-13%203-20%203a83%2083%200%2000-26%207c-3%200-7%202-8%203l-6%203-5%203-5%203-5%204-3%202-3%203-4%204c-2%202-2%204-3%2010-1%207-6%2020-8%2020l-13%2013c-3%203-4%207-5%2022%200%2014%201%2026%205%2029l3%207%204%207c3%204%204%2035%202%2083-1%2026-1%2031%204%2035l2%204a60%2060%200%200024%2018%20276%20276%200%2000182-34l7-3%208-4%207-3%205-3%206-3%206-3%206-4%203-2%2016-11a231%20231%200%200022-23l4-6%202-5%203-6%204-6a315%20315%200%200025-31c4-4%206-24%204-40-1-5-13-20-18-24a350%20350%200%2001-20-24l-4-7-2-5-4-6-3-5a127%20127%200%2000-26-24c-1-1-4-3-7-3H160m74%208l-41%201a273%20273%200%2000-76%207c-18%202-33%207-41%2014l-4%202-8%206c-6%207-6%207-6%2014-1%209-4%2014-14%2024-11%2011-11%2010-11%2026%200%2010%200%2013%202%2017a4755%204755%200%20017%2020c4%206%204%209%204%2064v52l3%205%2010%2010%208%204%205%203a167%20167%200%200084-3l14-4%2015-3%2012-3%206-3%209-3%207-3%204-2%208-4%206-3c2-1%205-3%208-3l6-3c1-1%204-3%207-3l8-4%206-3%205-3c2-2%205-3%207-3l4-3%205-3%206-4%204-3%204-3a468%20468%200%200118-18l3-5%204-5c4-9%207-15%2010-18l2-4%207-9c1%200%2011-9%2011-11l3-4c7-11%207-31%200-38l-5-6c-8-8-12-11-16-11-6%200-8-1-6-4%201-3-1-10-4-13l-3-7-4-6-2-5-3-5-3-6a64%2064%200%2000-26-23c-3-2-5-2-27-3l-32%201m-18%2050l-7%203-6%203-6%204-4%203c0%201-1%203-3%203-4%203-1%209%207%2016%205%203%208%204%2010%201l6-3%207-2c4-3%2015-5%2018-4%202%201%204%200%206-1l5-1%2012%202c16%202%2020-1%2016-11l-3-3-4-3c-9-7-46-12-54-7m3%208l-5%203c-3%200-5%202-6%203l-4%203c-3%201-4%204-2%206%202%201%2011-1%2015-4l6-3c5-1%206-3%203-6-1-3-5-4-7-2m-120%201c-4%201-7%204-7%209s2%206%2018%206l23%204c10%203%2010%204%2010%2011%200%206-3%209-11%2015l-8%205c-4%203-7%207-7%2010%200%202%204%204%208%204%203%200%208%204%2014%2010%204%204%2010%206%2016%204%2010-3%2010-8-1-8-6%200-6%200-11-4-4-5-7-9-7-11l10-10c3%200%205-7%206-14l1-7%204-3c7-3%206-7-2-9-3%200-12-5-16-9-4-3-30-5-40-3m204%2018l-10%204c-2%202-14%205-23%207-3%200-17-4-19-6l-5-4c-5-2-5-2-7%200s-1%206%202%208l5%203c6%206%2024%2010%2032%207l10-3%2010-3c14-10%2033-6%2040%207l4%207c2%204%201%207-2%2010-4%204-4%2010-1%2013s3%202%208-6c5-10%205-16%200-26-9-17-23-23-44-18m-240%208c-6%202-10%2010-6%2012%203%201%204%201%207-1%202-3%203-3%208-3%206%200%206%200%2011%205%207%207%208%207%2015%206%207%200%2015-6%2014-10-1-3-7-3-11%200l-3%202-2-2-6-4-8-4c-4-2-13-3-19-1m242%2012l-10%207c-3%200-5%202-6%203l-5%202-8%204-8%203c-3%200-6%201-8%203l-9%203-11%203-10%203-9%203-9%203c-5%200-14%202-17%204-4%202-22%204-33%204l-12%201-9%201a493%20493%200%2000-34-6l-7-3c-3-1-12-7-15-11-3-3-5-9-5-14%200-4-1-5-5-5s-4%201-8%2012l-4%2022c-1%2016%200%2042%202%2045l3%207%203%206%204%205c1%202%203%203%205%203l4%203c2%202%205%203%2014%204l13%203a482%20482%200%2000100-3l14-3c2-2%207-3%2010-4l7-3%206-3%205-3%205-3%206-4%2011-9a249%20249%200%200029-33l4-5c0-2%202-4%203-5%203-2%208-13%208-16s2-4%207-4c4%200%207-2%207-4l-11-9-4-6c-2-3-5-6-7-6l-6%205m-108%207c-5%203-3%206%204%207%205%202%207%206%205%2011-2%203-1%206%201%208%208%204%2013-13%207-22-4-4-12-6-17-4m106%206l-5%202-3%202c-1%201-4%203-7%203-6%203-11%208-11%2014l1%205c1%201%2013-3%2015-5l6-2c3-1%2013-12%2013-15%200-6-3-7-9-4m-125%207c-5%201-3%207%203%207l7%201c5%202%209%200%209-4l-2-4h-17m85%2010c-1%201-5%203-9%203l-11%204-9%203c-6%200-8%202-8%208%200%208%201%209%207%209%202-1%207-2%209-4l11-3c10-3%2017-13%2014-19%200-2-1-2-4-1M92%20210c-4%202-2%2012%203%2015%203%202%204%202%207-3s3-6-1-10c-2-4-5-5-9-2m110%200l-12%204c-7%200-9%203-9%209s1%207%2010%207l26-6c2-2%201-11-1-13-3-3-8-3-14-1m82%201l-5%205c-3%201-3%207-2%2010l1%203%203-2%208-8c7-8%207-11%202-11-2%200-5%201-7%203m-170%208c-4%207-1%2010%2012%2011h9l2-3c2-6%200-8-8-10-9-3-13-3-15%202m46-3c-12%204-14%205-14%209s4%205%2013%205c8%200%208-1%2010-4s2-3%200-7-4-5-9-3m98%207l-6%204c-5%201-17%206-19%208s0%2011%203%2016c4%206%208%207%2013%202%201-1%203-3%205-3l6-4%205-3%204-5c2-3%202-3%201-6l-2-6c0-5-5-6-10-3m-48%2017l-12%204c-9%203-10%203-10%2014%200%2012%201%2014%2010%2012l13-2%2011-3%205-3c3-1%204-5%201-7-2-2-4-7-4-11%200-6-5-8-14-4m-41%2011l-9%201c-7%200-7%200-8%203-2%206%201%2017%205%2019h18c5-2%207-16%203-21-2-2-7-3-9-2m-81%204c-3%208%201%2014%208%2013%204-1%203-5-4-14-2-2-2-2-4%201m16%200c2%208%205%2013%207%2015%207%204%2010-3%204-11l-4-5-4-1c-3%200-3%200-3%202m22%201c-4%207%209%2023%2015%2018%202-2%203-13%201-15-5-5-13-7-16-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5d77bfb8aeb207e785d8df46472dbdd9/ed0f7/MggFX7u.webp 64w"],
              "sizes": "(max-width: 64px) 100vw, 64px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5d77bfb8aeb207e785d8df46472dbdd9/6b377/MggFX7u.png 64w"],
              "sizes": "(max-width: 64px) 100vw, 64px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/5d77bfb8aeb207e785d8df46472dbdd9/6b377/MggFX7u.png",
              "alt": "MggFX7u",
              "title": "MggFX7u",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Today I wanted to show you some apps I built while researching this new stack for over a year. Best practices are still changing and we're just starting to see what's possible, but patterns are beginning to emerge.`}</p>
    <p>{`That's the perfect time to `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`jump into the future`}</a>{` ✌️`}</p>
    <h2 {...{
      "id": "serverlessreactdev-course-platform"
    }}>{`ServerlessReact.Dev course platform`}</h2>
    <p>{`Starting with my new course platform – great example of `}<em parentName="p">{`feeling pain`}</em>{` and `}<strong parentName="p">{`solving the problem`}</strong>{`.`}</p>
    <p>{`My ebooks used to live on Gumroad. Great checkout experience, just enough tools for creators, poor UX for consuming.`}</p>
    <p>{`So I switched to Teachable. You buy on Gumroad and a Zapier integration gives you a Teachable account with the right permissions.`}</p>
    <p>{`Teachable's authoring UX is `}<em parentName="p">{`terrible`}</em>{`.`}</p>
    <p>{`Markdown is my jam so I spent thousands of dollars on engineering to make Teachable work with markdown. Yes I legit hired an engineer to help me.`}</p>
    <p>{`The thought of making another course on Teachable filled me with dread.`}</p>
    <p>{`Looked around and Podia made me 😍 ... until I learned it doesn't do markdown, supports only 1 video per lesson, can't embed CodeSandbox, doesn't support random iframes (for graphql playgrounds :P), etc.`}</p>
    <p><em parentName="p">{`"Hey wait a minute, we just built an amazing platform for Serverless Handbook! Why don't we use that?"`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`Serverless Handbook`}</a>{` started life as the Rebass Docs. I love Rebass and I love their docs. So I `}<del parentName="p">{`stole`}</del>{` borrowed their open source Gatsby code.`}</p>
    <p>{`MDX support (markdown with React), fast loads, mobile design, static builds, even has themes for different colors 😍`}</p>
    <p>{`I CAN DO EVERYTHING THE POWER IS MINE`}</p>
    <p><img parentName="p" {...{
        "src": "/94481fe8e1b3e264ca44f9935834e3cb/media-3o84sq21TxDH6PyYms-giphy.gif",
        "alt": "power giphy"
      }}></img></p>
    <p>{`What does a course platform need that a free book doesn't have?`}</p>
    <p>{`Authentication and authorization.`}</p>
    <p>{`Sat down over a couple livestreams ... `}<strong parentName="p">{`and it worked`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=-b14ww6GXNY"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M12%205l-1%202c0%202-1%202-5%202H0v18h225V14l-6%201c-6%200-7%200-8-2-2-2-2-2-2%200%200%201%200%202-91%202-89%200-101%200-99-2l1-2%203-2a493%20493%200%200032-3L38%205a321%20321%200%2001-26%200m178%20101v12c1%202%2014%203%2017%201%203-1%203-1%203-7v-6l-10-1-10%201m-72%2037l-2%202c-3%200-3-1-3%2012%200%208-1%2012-2%207v-2l-56-1H0v64h401v-33c0-30%200-30-1-5v27h-15l-65-1-1-34v-34l-11-1c-13%200-13%200-12-1l-5-1-6%201a912%20912%200%2001-103%200l-23%201c-19%201-23%201-21-1%201-1%201-1-2-1l-3%201h-1l-7-1-7%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fc594e72244f75c07738fb8b0b524d36/ca0a1/techletter.app-screenshot-1580316667326.webp 223w", "/static/fc594e72244f75c07738fb8b0b524d36/75680/techletter.app-screenshot-1580316667326.webp 445w", "/static/fc594e72244f75c07738fb8b0b524d36/0ba47/techletter.app-screenshot-1580316667326.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fc594e72244f75c07738fb8b0b524d36/e92b6/techletter.app-screenshot-1580316667326.png 223w", "/static/fc594e72244f75c07738fb8b0b524d36/e66bf/techletter.app-screenshot-1580316667326.png 445w", "/static/fc594e72244f75c07738fb8b0b524d36/6af66/techletter.app-screenshot-1580316667326.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fc594e72244f75c07738fb8b0b524d36/6af66/techletter.app-screenshot-1580316667326.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=lwaHKXItp2k"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M2%202L1%203l4%201c8%202%208%205%201%205H0v7h12c10%200%2013-1%2010-3v-2c1-1%20125-2%20131%200%202%200%202%201%202%203l-1%202h71v-4c0-3%200-3-4-3s-5-1-4-5l-3-1c-2%200-3%200-2%201v1h-1l-83-2C-4%203%205%203%205%202L3%200%202%202m188%20104l-1%207c0%206%201%207%2011%207%209%200%2010-1%2010-8v-6l-10-1-10%201m-70%2037l-4%202c-2%200-3%200-3%204v12H93l-19%201-1%209-2%2012c-1%202-4%203-2%201l-1-1-1%201c-1%201-2%202-6%202-4-1-6%200-7%201h-3l-1-1-1%206v5l-2-3h-1c-3%202-3%201-3-11%200-9%200-11%202-12l1-2%201-2%203-2%207-3-26-1H0v64h401v-33c0-31%200-31-1-5v28h-39l-42-1h-3v-69h-36c-32%200-36%200-37-2h-1c-1%202-5%202-54%202a731%20731%200%2001-68-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/662d15d9785588e70554198c63a03d3a/ca0a1/techletter.app-screenshot-1580316666651.webp 223w", "/static/662d15d9785588e70554198c63a03d3a/75680/techletter.app-screenshot-1580316666651.webp 445w", "/static/662d15d9785588e70554198c63a03d3a/0ba47/techletter.app-screenshot-1580316666651.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/662d15d9785588e70554198c63a03d3a/e92b6/techletter.app-screenshot-1580316666651.png 223w", "/static/662d15d9785588e70554198c63a03d3a/e66bf/techletter.app-screenshot-1580316666651.png 445w", "/static/662d15d9785588e70554198c63a03d3a/6af66/techletter.app-screenshot-1580316666651.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/662d15d9785588e70554198c63a03d3a/6af66/techletter.app-screenshot-1580316666651.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You buy on Gumroad.`}</p>
    <p>{`Gumroad pings a serverless lambda function.`}</p>
    <p>{`Lambda function creates an Auth0 account. Gives you the Student role.`}</p>
    <p>{`You go to `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` and click Student Login.`}</p>
    <p>{`useAuth redirects you to the Auth0 login page.`}</p>
    <p>{`You come back and voila, access to the course.`}</p>
    <p><img parentName="p" {...{
        "src": "/eb154423bbc0f9ecd51269c9bc49b559/media-u0v3z2iQLxyHC-giphy.gif",
        "alt": "rock_on giphy"
      }}></img></p>
    <p>{`And THAT's what I want to teach you with `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` {% if subscriber.first_name != blank %} {{ subscriber.first_name | truncatewords: 1, "" | capitalize }} {% else %} my friend {% endif %}. `}<strong parentName="p">{`Spot a problem 👉 create the solution.`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1222387776970117120"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.29596412556054%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'234\\'%20viewBox=\\'0%200%20400%20234\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%205c-4%201-9%205-11%2010v12l2%202%201%201c-5%200%205%207%2011%208%204%200%206%200%209-2%206-3%206-4%202-5l-4-2c0-1%203-4%205-4s3-1%203-2c0-2%202-3%202-1%201%202%201-1%201-4C38%209%2027%203%2018%205\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/596dac8384023f900df2fd7532ed6c3e/ca0a1/H43WagD.webp 223w", "/static/596dac8384023f900df2fd7532ed6c3e/75680/H43WagD.webp 445w", "/static/596dac8384023f900df2fd7532ed6c3e/8d1ba/H43WagD.webp 890w", "/static/596dac8384023f900df2fd7532ed6c3e/9447f/H43WagD.webp 1294w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/596dac8384023f900df2fd7532ed6c3e/e92b6/H43WagD.png 223w", "/static/596dac8384023f900df2fd7532ed6c3e/e66bf/H43WagD.png 445w", "/static/596dac8384023f900df2fd7532ed6c3e/4ef49/H43WagD.png 890w", "/static/596dac8384023f900df2fd7532ed6c3e/d4377/H43WagD.png 1294w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/596dac8384023f900df2fd7532ed6c3e/4ef49/H43WagD.png",
              "alt": "H43WagD",
              "title": "H43WagD",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <h2 {...{
      "id": "techletterapp"
    }}>{`TechLetterApp`}</h2>
    <p><a parentName="p" {...{
        "href": "https://techletter.app/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "42.600896860986545%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'170\\'%20viewBox=\\'0%200%20400%20170\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M8%2019v11h8c10%200%2015-5%2010-11-2-1-2-2-1-3%203-2%202-5%200-7s-3-2-9-2H8v12M58%208v12l1%2010h6V7h-3l-4%201m21%203c0%204%200%204-2%203-6-6-13%204-9%2012%202%204%205%205%209%203h2l3%201h3V8l-3-1c-3%200-3%200-3%204m15%208v11h8c7%200%208-1%2010-3%203-3%202-5%200-7s-2-3-1-4c5-5%201-8-9-9h-8v12M199%208v12l1%2010h6v-6l1-5%204%205c3%205%204%206%206%206h3V7h-3c-3%200-4%201-4%206v5l-4-6c-4-5-8-7-10-4m88%200v12l1%2010h6V7h-3l-4%201m-151%203l-1%201-1%203%201%202%201%205c0%206%203%208%207%208%203-1%204-5%202-5s-2-1-2-4%200-4%202-4l1-2-1-3-2-2-3-1c-3%200-4%200-4%202m13%200l-1%201-1%203%201%202%201%205c0%206%203%208%207%208%203-1%204-5%202-5s-2-1-2-4%200-4%202-4l1-2-1-3-2-2-3-1c-3%200-4%200-4%202m168%200l-1%201-1%203%201%202%201%205c0%205%203%208%207%208%203-1%203-4%201-5s-3-7%200-8l1-3-1-2-2-1c0-1-1-2-3-2s-3%201-3%202m13%200l-1%201-1%203%201%202%201%205c0%206%203%208%207%208%203-1%204-5%202-5s-2-1-2-4%200-4%202-4l1-2-1-3-2-2-3-1c-3%200-4%200-4%202M30%2013c-2%202%200%2015%202%2016h9l3%201h3V12h-3c-3%200-3%200-3%205%200%206-1%209-3%208s-2-2-2-7c0-6%200-6-3-6l-3%201m20%208v9h6V12h-6v9m69-8c-5%203-5%2012-1%2015s10%202%2013-1l3-2-3-1-5%201h-4c-1-1%200-2%205-2%207-1%208-3%203-8-3-3-7-4-11-2m45%200c-4%202-5%2011-2%2015%203%202%209%203%2013%200s1-6-4-3h-4c-1-1%200-2%205-2s5-1%205-3c0-6-7-10-13-7m16%200l-1%209%201%208h6v-6c0-5%201-5%203-6%202%200%203-1%203-3s-2-4-4-2h-8m46%200c-4%202-5%2011-2%2015%203%202%209%203%2013%200s1-6-4-3h-4c-1-1%200-2%205-2s5-1%205-3c0-6-7-10-13-7m15%200l1%205%202%208c1%204%201%204%204%204s4%200%204-3c2-7%202-8%203-2%202%204%202%205%205%205h4l2-8%202-10-7%202-1%206v4l-1-6c-1-5-2-6-4-6-3%200-5%203-5%208l-1%202-1-3c0-5-1-7-4-7l-3%201m30%201c-3%203-1%209%204%209%202%200%205%202%204%203l-3-1h-7c0%203%204%205%209%205%209%200%2011-9%202-11l-5-1c0-1%202-2%203-1%202%202%207%201%207%200%200-5-10-7-14-3m29-1c-4%202-5%2011-2%2015%203%202%209%203%2013%200s1-6-4-3h-4c-2-2-1-2%205-2%205%200%205-1%205-3%200-6-7-10-13-7m43%201c-5%206-1%2016%207%2016%204%200%208-2%208-5%200-1-5-2-7%200h-2c-3-2-1-3%204-3h6l-1-3c-1-6-10-9-15-5m17-1v9l1%208h6v-6c0-5%201-6%203-6%201%200%202-1%202-3%200-3-2-4-4-2h-8m16%201c-4%203-3%207%204%209%203%201%204%202%203%203l-3-1h-7c0%202%205%205%208%205%2010%200%2013-9%203-11-3%200-5-2-4-3l3%201%205%201h3l-3-3c-3-3-8-4-12-1M196%2047c-3%202-2%205%202%209l4%205%203-4c5-4%205-6%203-9-2-2-2-2-4-1h-8M86%2077v6h52V71H86v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2cc7f85c36f71e21694594d1b887e4d0/ca0a1/InwptHv.webp 223w", "/static/2cc7f85c36f71e21694594d1b887e4d0/75680/InwptHv.webp 445w", "/static/2cc7f85c36f71e21694594d1b887e4d0/8d1ba/InwptHv.webp 890w", "/static/2cc7f85c36f71e21694594d1b887e4d0/3838e/InwptHv.webp 1335w", "/static/2cc7f85c36f71e21694594d1b887e4d0/e11e5/InwptHv.webp 1780w", "/static/2cc7f85c36f71e21694594d1b887e4d0/3c376/InwptHv.webp 1998w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2cc7f85c36f71e21694594d1b887e4d0/e92b6/InwptHv.png 223w", "/static/2cc7f85c36f71e21694594d1b887e4d0/e66bf/InwptHv.png 445w", "/static/2cc7f85c36f71e21694594d1b887e4d0/4ef49/InwptHv.png 890w", "/static/2cc7f85c36f71e21694594d1b887e4d0/4e814/InwptHv.png 1335w", "/static/2cc7f85c36f71e21694594d1b887e4d0/701e9/InwptHv.png 1780w", "/static/2cc7f85c36f71e21694594d1b887e4d0/1a867/InwptHv.png 1998w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/2cc7f85c36f71e21694594d1b887e4d0/4ef49/InwptHv.png",
              "alt": "InwptHv",
              "title": "InwptHv",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`You've seen this one before. It's the 24hrstartup challenge app that first made me excited about this modern new stack.`}</p>
    <p>{`Pat Walls posed a challenge in November 2018:`}</p>
    <p><em parentName="p">{`Can you build & launch a startup in 24 hours? Do it live on stream!`}</em></p>
    <p>{`Pat is crazy. There's no way.`}</p>
    <p>{`Fuck it let's try.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=sqlC1zNYG4M"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%201L0%2082v80h11v8c0%207-1%208-2%208H3l4%202c3%202%203%202%203%206s-2%2010-3%208H0v31h401V1l-2%201-3-1h-8l-1-1-2%201-2%201-2-1h-14l-2%201V1l-1-1-1%201h-10c-1%202%201%202-145%202A816%20816%200%200165%201h-9l-2-1-3%201H29l-1-1-2%201-2%201-2-1-2-1v1l-2%201-2-1-4-1-4%201-1%201-2-1H1m94%2022c-2%203%202%203%2068%203%2067%200%2068%200%2068-2s-1-2-68-2l-68%201M72%2094v68l-10%201H52l4%202c5%201%209%206%209%2010%200%202%200%202-3%201-2-1-4-1-9%202-8%203-9%204-6%207v3c-2%202%200%202%208%201%205-1%207-2%208-1h6a4597%204597%200%200136-3l105-1h96v14l1%2013%201-19v-20h9V55h-11V27H72v67m282-64a16243%2016243%200%2000-2%2094l-1%2046%201%2044%204%201h42v-3l1-94V27h-45v3m-164%2076v12c1%202%2011%202%2016%201l4-1v-12l-10-1-10%201M63%20193l-1%201c0-2-6-2-7%200h-1l-4-2c-5%200-6%202-2%203%203%202%205%204%207%209%201%204%206%204%2011%201l3-1v3c0%203%203%205%204%203%203-4%207-3%2010%203%202%203%203%200%201-4-2-3-3-4-7-5s-6-5-6-10l-1-2h-1c-2-1-5%200-6%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/021b43cdc97274c72525f1b3320e3e2d/ca0a1/techletter.app-screenshot-1580316667107.webp 223w", "/static/021b43cdc97274c72525f1b3320e3e2d/75680/techletter.app-screenshot-1580316667107.webp 445w", "/static/021b43cdc97274c72525f1b3320e3e2d/0ba47/techletter.app-screenshot-1580316667107.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/021b43cdc97274c72525f1b3320e3e2d/e92b6/techletter.app-screenshot-1580316667107.png 223w", "/static/021b43cdc97274c72525f1b3320e3e2d/e66bf/techletter.app-screenshot-1580316667107.png 445w", "/static/021b43cdc97274c72525f1b3320e3e2d/6af66/techletter.app-screenshot-1580316667107.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/021b43cdc97274c72525f1b3320e3e2d/6af66/techletter.app-screenshot-1580316667107.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`12 hours later `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetter.App`}</a>{` was born. 😳`}</p>
    <p>{`Write email in markdown as usual. Paste into box on the left, get rendered HTML on the right. Nothing special, just some markdown parsing and rendering.`}</p>
    <p>{`Now here's where it gets cool 👇`}</p>
    <p>{`This app uses an AWS Lambda to take screenshots of tweets, make youtube and instagram thumbnails, and make beautiful screenshots of code samples.`}</p>
    <p>{`I used to pay someone $500/month to do that for me.`}</p>
    <p>{`You see the power of TechLetter.App every time you read my emails 😉`}</p>
    <p>{`Yes I've fixed many bugs and added tiny little features since that first 24hr challenge. Even bought a domain to fully productize, but haven't.`}</p>
    <h2 {...{
      "id": "threadcompiler"
    }}>{`ThreadCompiler`}</h2>
    <p>{`This one died a prototype. You either die a prototype or become that code everyone hates to use.`}</p>
    <p>{`I realized I was playing catchup with Twitter's UX and that's a losing proposition right there. You can still try it out tho 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://threadcompiler.com/"
      }}><img parentName="a" {...{
          "src": "/8e47dea98eb8bc1ec0c81906efaf64fc/mrG7OQq.gif",
          "alt": null
        }}></img></a></p>
    <p>{`ThreadCompiler is an offline-first React app built with Gatsby. UI renders at compile time and becomes static. On page load the React app takes over and you can do whatever you want.`}</p>
    <p>{`In this case that's a combination of markdown parsing and rendering, talking to Auth0 to authenticate users with Twitter, and using another AWS Lambda to publish tweets.`}</p>
    <p>{`All built with JavaScript front and back. No databases, just Auth0.`}</p>
    <h2 {...{
      "id": "shared-grocery-list"
    }}>{`Shared grocery list`}</h2>
    <p>{`Yawn, a grocery list right? It's just a TODOapp.`}</p>
    <p>{`BUT THIS ONE IS REALLY COOL!`}</p>
    <p><a parentName="p" {...{
        "href": "https://shared-grocery-list.swizec.now.sh/"
      }}><img parentName="a" {...{
          "src": "/7c1447fa90814cbb444cff93ec405248/zrt3fMG.gif",
          "alt": null
        }}></img></a></p>
    <p>{`Check it out 👇`}</p>
    <ul>
      <li parentName="ul">{`Gatsby-based offline-first React UI`}</li>
      <li parentName="ul">{`Initial list compiled into the app at compile time with GraphQL`}</li>
      <li parentName="ul">{`On page load, uses GraphQL to ask a Serverless Lambda for current state`}</li>
      <li parentName="ul">{`Refreshes the UI`}</li>
      <li parentName="ul">{`All interactions sync right back to the Serverless Lambda with GraphQL`}</li>
      <li parentName="ul">{`Global list stored in a simple DB`}</li>
    </ul>
    <p>{`Server with user data, accessible by all, without writing a single specific API. No REST routes to manage, no servers to keep up, just a Lambda that responds to GraphQL queries.`}</p>
    <p>{`This was the example app for my sold-out workshop at Reactathon in March 2019. I'm doing `}<a parentName="p" {...{
        "href": "https://ti.to/real-world-react/modern-app-with-react-workshop-2020"
      }}>{`another one this march`}</a>{`.`}</p>
    <h2 {...{
      "id": "spark-joy"
    }}>{`Spark Joy`}</h2>
    <p>{`Spark Joy is where I really pushed this stack. `}<em parentName="p">{`We`}</em>{` pushed this stack. It was built during a live video series experiment mid 2019.`}</p>
    <p>{`You can try it out with the thumbsup/down buttons at the end of this email 😛`}</p>
    <p><a parentName="p" {...{
        "href": "https://spark-joy.netlify.com/"
      }}><img parentName="a" {...{
          "src": "/c004d017db2b0abcc74ff30eb5c06342/static-widget-demo-c004d017db2b0abcc74ff30eb5c06342.gif",
          "alt": null
        }}></img></a></p>
    <p>{`I like feedback. I really like feedback. `}<em parentName="p">{`On everything`}</em>{`.`}</p>
    <p>{`That's why any time you `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev/"
      }}>{`buy something from me`}</a>{` the first thing you get is a question: `}<em parentName="p">{`"Why did you buy this?"`}</em></p>
    <p>{`And why my emails used to have ugly typeforms: "Hey did you enjoy this?"`}</p>
    <p>{`That shit got tedious so I built Spark Joy. A simple thumbsup/down widget that gets all the info with much less friction.`}</p>
    <p>{`Where emails used to get 10, maybe 20, responses, they now get 60 and more. That's hella more feedback I can use to improve.`}</p>
    <p>{`It's also where the prototype for `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` was born. ✌️`}</p>
    <p>{`Spark-joy creates a new static page for every type of widget you create and triggers a Netlify build+deploy.`}</p>
    <p>{`So when you vote the page loads fast. None of that slow TypeForm crap.`}</p>
    <p>{`And this is just the beginning my friend. This hyper productive new stack blows my mind. `}<em parentName="p">{`So much is possible that wasn't before`}</em></p>
    <p><img parentName="p" {...{
        "src": "/fe91a3dc38b1981226c5c025fc759674/media-xT0xeJpnrWC4XWblEk-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I'm excited to see what you build.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: you can learn behind-the-scenes lessons of these projects and others in `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{`. The $100 launch discount ends on Friday.`}</p>
    <p>{`PPS: much of my excitement for this stack comes from lessons learned while building a 7-figure business from scratch on Rails, moving towards SinglePageApps, now JAMStack and Serverless at my day job. ServerlessReact.Dev really does include lessons from practice :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      